<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row>
        <v-col cols="12" xs12 class="ma-0 px-3 py-0">
            <v-text-field
                    label="Имя бота"
                    required
                    v-model="botModel.title"
                    :counter="50"
                    class="ma-0 pa-0"
                    :rules="[rules.required, rules.maxLengthTitle]"
            ></v-text-field>
        </v-col>
<!--        <v-col cols="12" xs12 class="ma-0 px-3 py-0">
            <v-tooltip left bottom>
                <template v-slot:activator="{ on }">
                    <v-text-field
                            label="Адрес бота (создается автоматически)"
                            v-model="botModel.hash_id"
                            readonly
                            class="ma-0 pa-0"
                            v-on="on"
                    ></v-text-field>
                </template>
                <span>Адрес создается автоматически при создании бота</span>
            </v-tooltip>
        </v-col>-->
        <v-col cols="12" xs12 class="ma-0 py-1 px-4">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="botModel.status"
                    inset
                    :label="botStatus" color="primary"
                    :false-value="2"
                    :true-value="1"
            ></v-switch>
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="autoAnswer"
                    inset
                    label="Переписка с администратором" color="primary"
                    :false-value="0"
                    :true-value="1"
            ></v-switch>
        </v-col>
        <v-col cols="6" xs12 class="ma-0 py-1 px-4 pr-2" v-show="autoAnswer > 0"><!--сообщение для профиля клиента-->
            <v-select
                    :items="messages"
                    class="ma-0 pa-0"
                    v-model="botModel.profile_message"
                    inset
                    label="Сообщение, которое придет после сообщения клиента:"
                    item-value="id"
                    item-text="title"
            ></v-select>
        </v-col>
        <v-col cols="6" xs12 class="ma-0 py-1 px-4 pl-2" v-show="autoAnswer > 0">
            <v-btn small @click="generateProfileMessage"><span class="text-none v-size--x-small">Сгенерить сообщение</span></v-btn>
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4">
            <v-select
                    :items="[{value: null, text: 'Обычный'}, {value: 'shop', text: 'Магазин'}]"
                    class="ma-0 pa-0"
                    v-model="botModel.style"
                    inset
                    label="Тип бота:"
                    @change="changeStyle"
            ></v-select>
        </v-col>

        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-select
                    :items="[{value: 'ru', text: 'Русский'}]"
                    class="ma-0 pa-0"
                    v-model="botModel.lang"
                    inset
                    label="Язык:"
            ></v-select>
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-select
                    :items="[{value: 1, text: 'Доставка еды'}, {value: 2, text: 'Автомойка'}, {value: 3, text: 'Салон услуг'}]"
                    class="ma-0 pa-0"
                    v-model="botModel.theme_id"
                    inset
                    label="Оформление бота:"
            ></v-select>
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-select
                    :items="[{value: 1, text: 'Рубль'}]"
                    class="ma-0 pa-0"
                    v-model="botModel.currency_id"
                    inset
                    label="Валюта:"
            ></v-select>
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="addWeightToKeyboard"
                    inset
                    label="Вес отображать в клавиатуре" color="primary"
                    :false-value="0"
                    :true-value="1"
           />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="groupItems"
                    inset
                    label="Группировать товары" color="primary"
                    messages="Если названия одинаковые, то товары объединяются"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="emptyImage"
                    inset
                    label="Установить стандартное изображение" color="primary"
                    messages="Если нет изображения товара, тогда будет вставлена стандартная фотография"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="promo"
                    inset
                    label="Принимать прокоды" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="showCountItems"
                    inset
                    label="Показывать число товаров в категории" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="buttonCancelOrder"
                    inset
                    label="Показывать кнопку отмены заказа у пользователя" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="buttonStatusPay"
                    inset
                    label="Показывать кнопку статуса платежа у менеджера" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="buttonDeleteMessage"
                    inset
                    label="Показывать кнопку удаления сообщения у менеджера" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="checkoutInline"
                    inset
                    label="Отображение кнопки подтвердить в отдельном сообщении с inline клавиатурой" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="checkoutButton"
                    inset
                    label="Наличие кнопки подтвердить заказ. При отсутствии кнопки заказ подтверждается автоматически" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="clientNameNotEdit"
                    inset
                    label="Запретить клиентам менять имя в настройках" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="basketOff"
                    inset
                    label="Выключить корзину" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="secretClientOn"
                    inset
                    label="Включить тайного покупателя" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="hideHelpInClientBox"
                    inset
                    label="Скрыть раздел помощь в личном кабинете клиента" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="showBalance"
                    inset
                    label="Показать баланс пользователя в личном кабинете" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="showPayButton"
                    inset
                    label="Показать кнопку потратить баллы в личном кабинете" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-select
                    :items="[ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                    label="Количество товаров на странице"
                    v-model="botModel.count_items"
                    class="ma-0 pa-0"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-select
                    :items="messages"
                    label="Главное ссобщение"
                    v-model="botModel.main_message"
                    class="ma-0 pa-0"
                    item-value="id"
                    item-text="title"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-text-field
                    label="Минимальная сумма для заказа"
                    v-model="botModel.min_price"
                    type="number"
                    class="ma-0 pa-0"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 px-4" v-show="botModel.style == 'shop'">
            <v-text-field
                    label="Подробная справка"
                    messages="Отображается в разделе помощь"
                    v-model="botModel.help"
                    class="ma-0 pa-0"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-text-field
                    label="Ссылка на договор публичной оферты"
                    messages="Отображается в разделе помощь"
                    v-model="botModel.terms"
                    class="ma-0 pa-0"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-text-field
                    label="Телефон"
                    messages="Обозначается как телефон горячей линии"
                    v-model="botModel.phone"
                    class="ma-0 pa-0"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-text-field
                    label="Электронная почта для уведомления о новых заказах"
                    messages="Перечислите через запятую несколько почтовых ящиков"
                    v-model="botModel.email"
                    class="ma-0 pa-0"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="emailSimple"
                    inset
                    label="Отправлять письма простым сообщением" color="primary"
                    :false-value="0"
                    :true-value="1"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-textarea
                    label="Описание магазина"
                    messages="Отображается в разделе помощь"
                    v-model="botModel.description"
                    class="ma-0 pa-0"
            />
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4" v-show="botModel.style == 'shop'">
            <v-textarea
                    label="Текст приветствия"
                    v-model="botModel.welcome_text"
                    class="ma-0 pa-0"
            />
        </v-col>
        <dialog-confirmation
                ref="confirm"
        />
    </v-row>
</template>

<script>
import botConstants from './botConstants'
import { mapGetters } from 'vuex'
import DialogConfirmation from '../../dialogs/DialogConfirmation'

export default {
    name: 'BotFormMain',
    props: {
        botModel: {
            default: function() {
                return {
                    id: null,
                    theme_id: null,
                    welcome_text: null,
                    count_items: null,
                    currency_id: null,
                    profile_message: null
                }
            },
            type: Object
        }
    },
    data() {
        return {
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 50) || 'Максимальная длина названия 20 символов.'
            },
            selectedItems: [0, 0, 0, 0, 0]
        }
    },
    components: {
        DialogConfirmation
    },
    computed: {
        ...mapGetters({
            messages: 'messages/getMessagesWithNull'
        }),
        botStatus() {
            return this.botModel.status === 2 ? 'Бот выключен' : 'Бот включен'
        },
        emailSimple: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.emailSimple)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.emailSimple, value)
            }
        },
        showCountItems: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.showCountItems)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.showCountItems, value)
            }
        },
        promo: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.promo)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.promo, value)
            }
        },
        emptyImage: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.emptyImage)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.emptyImage, value)
            }
        },
        groupItems: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.groupItems)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.groupItems, value)
            }
        },
        addWeightToKeyboard: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.addWeightToKeyboard)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.addWeightToKeyboard, value)
            }
        },
        buttonCancelOrder: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.buttonCancelOrder)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.buttonCancelOrder, value)
            }
        },
        buttonStatusPay: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.buttonStatusPay)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.buttonStatusPay, value)
            }
        },
        buttonDeleteMessage: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.buttonDeleteMessage)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.buttonDeleteMessage, value)
            }
        },
        checkoutInline: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.checkoutInline)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.checkoutInline, value)
            }
        },
        checkoutButton: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.checkoutButton)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.checkoutButton, value)
            }
        },
        basketOff: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.basketOff)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.basketOff, value)
            }
        },
        secretClientOn: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.secretClientOn)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.secretClientOn, value)
            }
        },
        hideHelpInClientBox: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.hideHelpInClientBox)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.hideHelpInClientBox, value)
            }
        },
        showBalance: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.showBalance)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.showBalance, value)
            }
        },
        showPayButton: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.showPayButton)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.showPayButton, value)
            }
        },
        autoAnswer: {
            get() {
                let value = this.botModel.setting_public & (1 << botConstants.settingPublicAutoAnswer)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingPublic(botConstants.settingPublicAutoAnswer, value)
            }
        },
        clientNameNotEdit: {
            get() {
                let value = this.botModel.setting_shop & (1 << botConstants.clientNameNotEdit)
                return value ? 1 : 0
            },
            set(value) {
                this.setBitSettingShop(botConstants.clientNameNotEdit, value)
            }
        }
    },
    methods: {
        setBitSettingShop(bit, value) {
            if (value) {
                this.botModel.setting_shop = this.botModel.setting_shop | (1 << bit)
            } else {
                this.botModel.setting_shop = this.botModel.setting_shop & (~(1 << bit))
            }
        },
        setBitSettingPublic(bit, value) {
            if (value) {
                this.botModel.setting_public = this.botModel.setting_public | (1 << bit)
            } else {
                this.botModel.setting_public = this.botModel.setting_public & (~(1 << bit))
            }
        },
        async changeStyle() {
            if (this.botModel.style && !this.botModel.main_message) {
                if (await this.$refs.confirm.open('Уведомление', 'Сгенерировать главное сообщение с готовой клавиатурой?', { color: 'green',
                    agree: 'Да',
                    cancel: 'Нет' })) {
                    this.$emit('save')
                    this.$store.dispatch('messages/generateMainMessage', { botId: this.botModel.id, themeId: this.botModel.theme_id }).then(
                        response => {
                            let messageId = response.response.data.id
                            if (response.ok) {
                                this.$store.dispatch('messages/messageAll', this.botModel.id).then(response => {
                                    if (response) {
                                        this.botModel.main_message = messageId
                                        this.$emit('save')
                                    }
                                })
                            }
                        }
                    )
                }
            }
        },
        async generateProfileMessage() {
            if (await this.$refs.confirm.open('Уведомление', 'Сгенерировать сообщение с профилем клиента и с готовой клавиатурой?', { color: 'green',
                agree: 'Да',
                cancel: 'Нет' })) {
                this.$emit('save')
                this.$store.dispatch('messages/generateProfileMessage', { botId: this.botModel.id, themeId: this.botModel.theme_id }).then(
                    response => {
                        let messageId = response.response.data.id
                        if (response.ok) {
                            this.$store.dispatch('messages/messageAll', this.botModel.id).then(response => {
                                if (response) {
                                    this.botModel.profile_message = messageId
                                    this.$emit('save')
                                }
                            })
                        }
                    }
                )
            }
        }
    },
    watch: {
        botModel() {
            if (this.botModel.style === 'shop') {
                this.$store.dispatch('messages/messageAll', this.botModel.id)
            }
        }
    },
    created() {
        if (this.botModel.style === 'shop') {
            this.$store.dispatch('messages/messageAll', this.botModel.id)
        }
    }
}
</script>

<style scoped>

</style>
